import { createSelector } from 'reselect';

import { selectEntitiesMatchesEntitySportId } from '../../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { makeIsMatchLineUpAvailableWithFullDataSelector } from '../../../../selectors/match.selector';
import { type Selector } from '../../../../types/selectors';
import { type SportId } from '../../../../types/sports';

type LineUpOpenViewButtonPropsType = {
  isVisible: boolean;
  sportId?: SportId;
};

const selectLineUpOpenViewButtonProps: Selector<LineUpOpenViewButtonPropsType> = createSelector(
  [makeIsMatchLineUpAvailableWithFullDataSelector(), selectEntitiesMatchesEntitySportId],
  (isMatchLineUpAvailableWithFullData, sportId) => ({
    isVisible: isMatchLineUpAvailableWithFullData,
    sportId: sportId,
  }),
);

export default selectLineUpOpenViewButtonProps;
